import React, { useEffect, useState } from 'react';

import { styled } from '@mui/material/styles';
import { Address, Billing, Contact, Copy, Customer, CustomerInfo, EmailBox, Filter, Payment, Phone, Shipping, ShippingID, ShippingMethod, Users } from '../../Svg';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  Chip,
  MenuItem,
  Menu,
  Button,
  Paper,
  Typography,
  Box,
  Divider, Grid

} from "@mui/material";
import { ArrowDropDown } from '@mui/icons-material';
import { getSampleRequestDetailsThunk, setSampleRequestrefresh } from '../../redux/sampleRequestSlice';
import { handleCopy, stripHtmlTags } from '../../utils/fomateDate';
import { toast } from 'react-toastify';
import api from '../../utils/api';



const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const New = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4A4C561A',
  color: '#4A4C56',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));
const Delivered = styled(Chip)(({ theme }) => ({
  backgroundColor: '#E9FAF7',
  color: '#1A9882',
  fontWeight: 'bold',
  borderRadius: '4px',
  lineHeight: '24px',
  fontSize: '12px',
  fontFamily: `'Public Sans', sans-serif !important`,
}));

const SampleReqDetails = (setStatus,) => {

  const { sampleRequestDetails, loading, refresh, page } = useSelector((state) => state.samplerequest);
  const [updateloading, setLoading] = useState(false)

  const dispatch = useDispatch()
  const { id } = useParams()
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      changeStatus(status)
    }
    setAnchorEl(null);
  };


  const changeStatus = async (status) => {
    const datas = {
      id: id,
      status: status
    }
    try {
      const { data } = await api.updatesampleRequestStatus(datas)
      if (data) {
        toast.success('status updated succesfully')
        dispatch(setSampleRequestrefresh())
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'something went wrong')
    }
  }



  useEffect(() => {
    dispatch(getSampleRequestDetailsThunk(id))
  }, [refresh])


  // console.log(sampleRequestDetails);

  return (
    <>
      <NestedUserHeader
        index=" Enquiry #20192"
        root="Dashboard"
        buttonText={'Add Subcategory'}
      />


      <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
        <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
          <div style={{ display: 'flex' }}>
            <Typography
              sx={{
                color: 'rgba(29, 31, 44, 1)',
                fontSize: '20px',
                fontWeight: '600',
                fontFamily: `'Public Sans', sans-serif`,
              }}>
              ID #{sampleRequestDetails?._id}
            </Typography>
            <Typography style={{
              marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
              color: '#01A1FE',
              background: "#EFF9FF",
            }}>
              {sampleRequestDetails?.status === "NEW" ? (
                <New label="New" size="small" />
              ) : (
                <Delivered label="Completed" size="small" />
              )}
            </Typography>
          </div>
          <div>
            <ActionButton
              onClick={handleClick}
              sx={{
                color: '#667085',
                border: '1px solid #E0E2E7',
                background: '#fff',
                borderRadius: '8px',
              }}
            >
              {sampleRequestDetails?.status}
              <ArrowDropDown />
            </ActionButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={()=>handleClose('')}
              MenuListProps={{
                'aria-labelledby': 'status-button',
              }}
            >
              <MenuItem onClick={() => handleClose('NEW')}
                sx={{
                  borderBottom: '1px solid #E6E1E5',
                  fontSize: '14px',
                  color: '#667085',
                }}>New</MenuItem>
              <MenuItem onClick={() => handleClose('COMPLETED')}
                sx={{
                  fontSize: '14px',
                  color: '#667085',
                }}>Completed</MenuItem>
            </Menu>
          </div>
        </div>

        {loading ? <div>Please wait...</div> :
          <Box maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item xs={12} md={7}>
                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <CustomerInfo />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Customer Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Customer />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Company:
                        </Typography>
                        <Box>
                          {/* Company first; the contact person's name below it */}
                          <Typography style={{ color: '#0C0D0F', fontSize: '14px', fontWeight: 600 }}>
                            {sampleRequestDetails?.user?.companyName || sampleRequestDetails?.user?.fullName || 'Customer unavailable'}
                          </Typography>
                          {sampleRequestDetails?.user?.companyName && sampleRequestDetails?.user?.fullName && (
                            <Typography style={{ color: '#727A90', fontSize: '13px' }}>{sampleRequestDetails.user.fullName}</Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <EmailBox />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Email:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {sampleRequestDetails?.user?.email}

                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(sampleRequestDetails?.user?.email)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Phone />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Phone Number:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {sampleRequestDetails?.user?.phone}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(sampleRequestDetails?.user?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Address />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px' >
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Shipping Address:
                        </Typography>
                        {/* {sampleRequestDetails?.user?.shippingAddress?.map((i) => (

                          <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                            {i?.factoryUnits} <br /> {i?.streetAddress}, {i?.state}-{i?.zipCode}, {i?.country}
                          </Typography>x
                        ))
                        } */}
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px' flexWrap={'wrap'} >
                       
                        {sampleRequestDetails?.user?.shippingAddress?.map((i) => (

                          <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                            {i?.factoryUnits} <br /> {i?.streetAddress}, {i?.state}-{i?.zipCode}, {i?.country}
                          </Typography>
                        ))
                        }
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>


              <Grid item xs={12} md={5}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px", height: '100%' }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Contact />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Enquiry Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" flexDirection="column" gap='10px'>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div>
                            {sampleRequestDetails?.product?.assets?.featuredImage?.length > 0 ?
                              <img src={sampleRequestDetails?.product?.assets?.featuredImage[0]} style={{ width: 50, height: 50 }} />
                              :
                              <img src="/assets/profile.png" />
                            }
                          </div>
                          <div>
                            <strong style={{ color: '#1D1F2C' }}>{sampleRequestDetails?.product?.productOverview?.productNumber[0]}</strong>
                            <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500', }}>
                              {stripHtmlTags(sampleRequestDetails?.product?.productOverview?.description?.[0] || sampleRequestDetails?.product?.description)}
                            </div>
                          </div>
                        </div>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Project name:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {sampleRequestDetails?.projectName}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Application:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {sampleRequestDetails?.application}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Quantity:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {sampleRequestDetails?.quantity}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          End customer:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {sampleRequestDetails?.endUser}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>


            </Grid>


          </Box>
        }
      </div>
    </>
  );
};

export default SampleReqDetails;
